var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12244 10.1129L5.83088 11.4355C6.05133 11.656 6.54733 11.7662 6.87799 11.7662H8.97221C9.63355 11.7662 10.35 11.2702 10.5153 10.6089L11.838 6.58577C12.1135 5.81421 11.6175 5.15288 10.7909 5.15288H8.58644C8.25577 5.15288 7.98021 4.87732 8.03533 4.49154L8.31088 2.72799C8.4211 2.23199 8.09044 1.68088 7.59444 1.51554C7.15355 1.35021 6.60244 1.57065 6.38199 1.90132L4.12244 5.2631",
    stroke: "black",
    strokeWidth: 0.826667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31177 10.1129V4.712C1.31177 3.94044 1.64243 3.66489 2.41399 3.66489H2.9651C3.73666 3.66489 4.06732 3.94044 4.06732 4.712V10.1129C4.06732 10.8844 3.73666 11.16 2.9651 11.16H2.41399C1.64243 11.16 1.31177 10.8844 1.31177 10.1129Z",
    stroke: "black",
    strokeWidth: 0.826667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDefault);
export default __webpack_public_path__ + "static/media/like-default.0a21d97e1fece24d13e44a4a2b494ca5.svg";
export { ForwardRef as ReactComponent };